export default __webpack_public_path__ + "static/media/modern-kitchen-cleaning-realistic-background_1441-2798@2x.4c093fa3.png";